exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-app{background-color:#eff2f5}.my-app .charge-list{border-bottom:.026667rem solid #e9e9e9}.my-app .charge-list .fr{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17e54d9e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/inpatientRecharge/MyRecharge.vue
// module id = 415
// module chunks = 0